export const NZ_TZ = "Pacific/Auckland";

// Format an ISO/UTC timestamp for display in New Zealand time (auto-handles NZDT/NZST).
// Appends a small "NZT" label so the timezone is always clear. Pass { tag: false } to omit it.
export const fmtNZ = (iso, opts) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  const { tag, ...fmt } = opts || {};
  const s = d.toLocaleString("en-NZ", { timeZone: NZ_TZ, ...fmt });
  return tag === false ? s : `${s} NZT`;
};
